import _ from 'lodash';
import { isDataModeOn } from '#packages/wixData';
import type {
  MapStateToProps,
  MapDispatchToProps,
  ThunkAction,
} from 'types/redux';
import type {
  ApplicationSettingsPanelTabsDispatchProps,
  ApplicationSettingsPanelTabsOwnProps,
  ApplicationSettingsPanelTabsStateProps,
} from './applicationSettingsPanelTabs';
import type { RouterRef } from '@wix/document-services-types';

const mapStateToProps: MapStateToProps<
  ApplicationSettingsPanelTabsStateProps,
  ApplicationSettingsPanelTabsOwnProps
> = ({ editorAPI }, props) => {
  const pagesData = editorAPI.pages.getPagesData();
  const publicUrl = editorAPI.dsRead.generalInfo.getPublicUrl();
  const pageRef = editorAPI.components.get.byId(props.menuItem.pageData.id);
  const dataModeIsOn = isDataModeOn(editorAPI);
  let routerData = {};
  let routerRef: RouterRef | undefined;
  if (pageRef) {
    routerRef = editorAPI.dsRead.routers.getRouterRef.byPage(pageRef);
    routerData = routerRef ? editorAPI.dsRead.routers.get.byRef(routerRef) : {};
  }
  return {
    pageRef,
    routerRef,
    dataModeIsOn,
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line you-dont-need-lodash-underscore/find
    pageData: _.find(pagesData, { id: props.menuItem.pageData.id }),
    publicUrl,
    routerData,
  };
};

const getAppDataByAppDefId =
  (appDefId: string): ThunkAction =>
  (dispatch, getState, { editorAPI }) =>
    editorAPI.dsRead.platform.getAppDataByAppDefId(appDefId);

const mapDispatchToProps: MapDispatchToProps<
  ApplicationSettingsPanelTabsDispatchProps,
  ApplicationSettingsPanelTabsOwnProps
> = (dispatch) => ({
  getAppDataByAppDefId(appDefId: string) {
    return dispatch(getAppDataByAppDefId(appDefId));
  },
});

export { mapStateToProps, mapDispatchToProps };
